import script from "./CaseConversion.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseConversion.vue?vue&type=script&setup=true&lang=js"

import "./CaseConversion.vue?vue&type=style&index=0&id=36d2a05a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d2a05a"]])

export default __exports__